import { Catalog } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Библиотеки с версиями (БО-11, Приложение D «библиотеки»): шаблоны записей (Приложение A), шаблоны баз знаний,
 * «симптом → специальность», красные флаги (Приложение B.3), шаблоны WhatsApp и модерация Meta (ИНТ-02),
 * справочники (ИНТ-60). Чтение — все роли DODOC_*; черновики AI-администратора — DODOC_QA и DODOC_ADMIN;
 * публикация и справочники — DODOC_ADMIN; шаблоны WhatsApp — DODOC_ADMIN и DODOC_SUPPORT.
 */
export const section = defineSection({
  id: 'backoffice.libraries',
  area: 'backoffice',
  path: 'libraries/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT', 'DODOC_QA', 'DODOC_MODERATOR'],
  icon: Catalog,
  titleKey: 'libraries:title',
  namespaces: ['backoffice', 'scribeAdmin', 'scribe', 'assistantKb', 'portal'],
  navGroup: 'library',
  order: 100,
  load: () => import('./LibrariesPage'),
});
